import React, { FC } from 'react';
import { SimpleManageSubscriptionTableTile, SimpleManageSubscriptionTile } from './simple/SimpleManageSubscriptionTile';
import {
    ExtendedManageSubscriptionTableTile,
    ExtendedManageSubscriptionTile
} from './extended/ExtendedManageSubscriptionTableTile';

type Props = SimpleManageSubscriptionsCells | ExtendedManageSubscriptionsCells;

export const ManageSubscriptionsTableBody: FC<Props> = ({ type, list }) => {
    switch (type) {
        case 'SimpleManageSubscriptionsCells':
            return <SimpleManageSubscriptionsBody list={list} />;
        case 'ExtendedManageSubscriptionsCells':
            return <ExtendedManageSubscriptionsBody list={list} />;
        default:
            return <tbody></tbody>;
    }
};

export type SimpleManageSubscriptionsCells = {
    type: 'SimpleManageSubscriptionsCells';
    list: SimpleManageSubscriptionTile[];
};

type SimpleManageSubscriptionsBodyProps = Omit<SimpleManageSubscriptionsCells, 'type'> & {};

export const SimpleManageSubscriptionsBody: FC<SimpleManageSubscriptionsBodyProps> = props => {
    return (
        <tbody className="simple">
            {props.list.map(item => {
                return <SimpleManageSubscriptionTableTile key={item.product.id} {...item} />;
            })}
        </tbody>
    );
};

export type ExtendedManageSubscriptionsCells = {
    type: 'ExtendedManageSubscriptionsCells';
    list: ExtendedManageSubscriptionTile[];
};

type ExtendedManageSubscriptionsBodyProps = Omit<ExtendedManageSubscriptionsCells, 'type'>;

export const ExtendedManageSubscriptionsBody: FC<ExtendedManageSubscriptionsBodyProps> = props => {
    return (
        <tbody className="extended">
            {props.list.map(item => {
                return <ExtendedManageSubscriptionTableTile key={item.product.id} {...item} />;
            })}
        </tbody>
    );
};
